import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import AdminWarRoom from '../../components/admin/AdminWarRoom';

const AdminWarRoomPage = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-white">War Room</h1>
          <p className="text-gray-400 mt-1">Mapa de densidad hiperlocal en tiempo real</p>
        </div>
        
        <AdminWarRoom />
      </div>
    </AdminLayout>
  );
};

export default AdminWarRoomPage;
